import { performLogout } from '@/utils/logout';
import { useCallback } from 'react';

export default function useLogout() {
  const logout = useCallback(async () => {
    // 调用通用的退出登录函数，不进行重定向（由当前函数处理）
    await performLogout();
  }, []);

  return { logout };
}
